import { observable } from 'mobx';

import { DrugList } from '@store/models/SystemFields/Drug';

export class DrugStore {
    public static readonly Name = 'drugStore';

    @observable public drugList: DrugList = new DrugList();
}

export const drugStore = new DrugStore();
